"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSustainabilityReport = function IconSustainabilityReport(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M35 5H9v33a5 5 0 0 0 5 5h21v-4.03h4v-29h-2v27h-2zm-2 36H14l-.176-.005A3 3 0 0 1 11 38V7h22zm-3-8.03v-1H14v1zm0 3v1H14v-1zm-7.62-25.719 1.116 1.421-.021.017.07.08c.449.517 1.154 1.489 1.833 2.503l.335.51.339.529c1.512 2.407 2.281 4.274 2.258 5.61l.002.223c-.018 3.047-2.283 5.595-5.312 6.01v1.816h-1v-1.78c-3.203-.28-5.667-3.016-5.57-6.24l.005-.19c.07-1.414.912-3.321 2.484-5.78l.464-.706a48 48 0 0 1 1.353-1.909l.33-.438zM22 25.185c-2.04-.245-3.635-2.058-3.57-4.205 0-.928.662-2.509 1.988-4.63l.267-.419c.47-.726.976-1.45 1.482-2.137l.216-.292.249.337c.514.704 1.04 1.464 1.526 2.221 1.39 2.16 2.104 3.791 2.15 4.747l.002.126c.061 2.08-1.372 3.82-3.31 4.202v-3.428l1.634-1.633-.707-.708-.927.927V17.97h-1v4.273l-1.546-1.547-.707.707L22 23.658z",
    clipRule: "evenodd"
  })));
};

export { IconSustainabilityReport, IconSustainabilityReport as default };
